module.exports = __webpack_public_path__ + "img/quote.162b57f3.svg";